import React from 'react';
import uniqid from 'uniqid';
import { addDetail } from '../../action/BorrowerDocumentAction';
import constant from '../../constant';
import WithToastContext from '../../context/ToastContext';
import { onChange, validateForm } from '../../utils';
import DropZone from '../common/DropZone';
import Loader from '../common/Loader';

interface IPropType {
    loanDetail: any,
    onSubmitComplete: any,
    context: any,
}

class UploadDocumentForm extends React.Component<IPropType, any>{

    constructor(props: any) {
        super(props);


        this.state = {
            showLoader: false,
            uid: uniqid(),
            documentList: { name: 'documentList', required: true, error: '', value: '', type: constant.fieldType.string },
            remarks: { name: 'remarks', required: false, error: '', value: '', type: constant.fieldType.string },
        }
    }

    render() {
        const { showLoader, remarks, documentList } = this.state;
        return (
            <div>
                {
                    showLoader && <Loader />
                }
                <div className="form-group">
                    <DropZone onUploadComplete={(e: any) => this.onChange({ target: { name: documentList.name, value: e } })} />
                </div>
                <div className="form-group">
                    <label>Remarks</label>
                    <textarea
                        rows={3}
                        className={remarks.error.length > 0 ? "form-control is-invalid" : "form-control"}
                        placeholder=""
                        name={remarks.name}
                        value={remarks.value}
                        onChange={this.onChange}
                    />
                </div>
                {/* <div className="mb-3">
                    <small>Note: To add more than one email add a comma(",") between them without any space</small>
                </div> */}
                <div className="row">
                    <div className="col-12 text-right">
                        <button className="btn btn-primary px-5" onClick={this.onSubmit} type="button">Upload Files</button>
                    </div>
                </div>
            </div >
        );
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        onChange(this, name, value);
    }

    onSubmit = () => {
        if (validateForm(this)) {
            const { loanDetail } = this.props;
            const { uid, remarks, documentList } = this.state;

            const model = new FormData();

            model.append('loanDetailId', `${loanDetail.id}`);
            model.append('uid', uid);
            model.append('comment', remarks.value);
            for (let i = 0; i < documentList.value.length; i++) {
                model.append('file', documentList.value[i]);
            }

            this.setState({ showLoader: true })
            addDetail(model).then((res: any) => {
                this.setState({ showLoader: false });
                if (res.error) {
                    this.props.context.toast.error(res.error);
                }
                else {
                    this.props.context.toast.success(constant.message.recordUpdated);
                    this.props.onSubmitComplete(res.result);
                }
            })
        }
    }
}

export default WithToastContext(UploadDocumentForm);